import { Button } from '@arco-design/web-react';
import { IconDelete, IconEdit } from '@arco-design/web-react/icon';

import { VolumeOptionLabel } from '@/components/Workload/storage-settings';

import { VendorDevicePersistFields } from '../vendorDevice';
import styles from './index.module.less';
import type { ResourceConfigCardProps } from './types';

/** 资源配置卡片：摘要展示 + 内置厂商设备隐藏 FormItem */
export function ResourceConfigCard({
  resourceCode,
  vendorDevicePrefix,
  icon,
  title,
  items,
  canEdit,
  canDelete,
  hasError,
  onEdit,
  onDelete,
}: ResourceConfigCardProps) {
  const [specItem, ...extraItems] = items;

  return (
    <div
      className={[styles.summaryCard, hasError ? styles.summaryCardError : ''].filter(Boolean).join(' ')}
      data-resource-code={resourceCode}
    >
      {vendorDevicePrefix ? <VendorDevicePersistFields fieldPrefix={vendorDevicePrefix} /> : null}
      <div className={styles.summaryMain}>
        <VolumeOptionLabel
          iconfontName={icon}
          label={title}
          value={specItem?.value || '-'}
          valueLineClamp={3}
          extraItems={extraItems.map((item) => ({
            label: item.label,
            value: item.value || '-',
            frozenWidth: false,
          }))}
          style={{ flex: 1 }}
        />
        {canEdit || canDelete ? (
          <div className={styles.summaryActions}>
            {canEdit ? <Button iconOnly type="text" icon={<IconEdit />} onClick={onEdit} /> : null}
            {canDelete ? <Button iconOnly type="text" status="danger" icon={<IconDelete />} onClick={onDelete} /> : null}
          </div>
        ) : null}
      </div>
    </div>
  );
}
